import { windowWidth, windowHeight } from './constants';
import { UIScene } from './UIScene';
import { Preloader } from './Preloader';
import { Splash, Credits, Pause } from './menus';
import { Level } from './Level';


class SpaceGame {
    game: Phaser.Game;

    constructor() {
        const config: Phaser.Types.Core.GameConfig = {
            type: Phaser.AUTO,
            input: {
                // Enable the gamepad plugin (off by default in Phaser 3) so the
                // controller handling in Level.handleInput actually runs.
                gamepad: true
            },
            scale: {
                // Keep the internal resolution fixed at windowWidth x windowHeight
                // so the camera always shows the same slice of the world (scaling
                // up wouldn't make the game easier), and just fit/center the whole
                // canvas into its parent - letterboxed, pixelated when enlarged.
                mode: Phaser.Scale.FIT,
                autoCenter: Phaser.Scale.CENTER_BOTH,
                parent: 'content',
                width: windowWidth,
                height: windowHeight
            },
            physics: {
                default: 'arcade',
                arcade: {
                    gravity: { x: 0, y: 0 },
                    debug: false
                }
            },
            scene: [Preloader, Splash, Credits, Level, UIScene, Pause]
        };

        this.game = new Phaser.Game(config);

        // Give the canvas keyboard focus as soon as it exists (and again whenever
        // the window regains focus), so keyboard AND controller input work right
        // away - the player can start with a key or a controller button without
        // having to click the page first. (The Gamepad API only delivers input to
        // a focused document, so without this a controller does nothing on the
        // splash until you click.)
        const focusCanvas = () => {
            const canvas = this.game.canvas;
            if (canvas) {
                canvas.focus();
            }
        };
        this.game.events.once(Phaser.Core.Events.READY, () => {
            const canvas = this.game.canvas;
            if (canvas) {
                canvas.setAttribute('tabindex', '0'); // a <canvas> isn't focusable without this
                canvas.style.outline = 'none';          // no focus ring
            }
            focusCanvas();
        });
        this.game.events.on(Phaser.Core.Events.FOCUS, focusCanvas);
    }
}


window.onload = () => {
    var game = new SpaceGame();
};